import { useEffect } from "react";

/**
 * Full-screen modal that shows an image. Click backdrop or press Escape
 * to close. Renders nothing when `src` is falsy.
 */
export default function Lightbox({ src, onClose, testId }) {
  useEffect(() => {
    if (!src) return () => {};
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [src, onClose]);

  if (!src) return null;
  return (
    <div
      onClick={onClose}
      className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-6 no-print"
      data-testid={testId}
    >
      <img src={src} alt="preview" className="max-h-[90vh] max-w-[90vw] rounded-xl shadow-2xl" />
    </div>
  );
}
